/**
 * Stat cards of the supplier profile's Questionnaires tab. Every questionnaire
 * lands in exactly one bucket, so the cards always add up to Total.
 */
export interface QuestionnaireStats {
  total: number;
  approved: number;
  /** Submitted or under review — waiting on the customer. */
  pendingReview: number;
  /** Being answered, or sent back for more information (and any unknown status). */
  inProgress: number;
  /** Sent, not started yet. */
  invited: number;
  /** Rejected or expired. */
  closed: number;
}

/**
 * Counts per stat card.
 *
 * @param questionnaires - the supplier's questionnaires
 * @returns one count per card; approved + pendingReview + inProgress + invited + closed === total
 */
export function questionnaireStats(questionnaires: { status: string }[]): QuestionnaireStats {
  const stats: QuestionnaireStats = { total: 0, approved: 0, pendingReview: 0, inProgress: 0, invited: 0, closed: 0 };
  for (const q of questionnaires) {
    stats.total += 1;
    const status: string = q.status;
    if (status === 'approved') stats.approved += 1;
    else if (status === 'submitted' || status === 'under_review') stats.pendingReview += 1;
    // CR-8252: an onboarding questionnaire not yet started is 'not_started'.
    else if (status === 'invited' || status === 'not_started') stats.invited += 1;
    else if (status === 'rejected' || status === 'expired') stats.closed += 1;
    else stats.inProgress += 1;
  }
  return stats;
}
